import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import $ from 'jquery';
import Popper from 'popper.js';
import axios from 'axios';

import 'bootstrap/dist/css/bootstrap.css';


import './css/custom.css'
import './css/fa/css/font-awesome.css'

const isMock = process.env.REACT_APP_MOCK === '1';

// Real-login mode: withAuthenticator's custom component slots (SignIn.Footer /
// SignUp.Footer in comps/auth/theme/settings.js) call useAuthenticator(), which
// requires an <Authenticator.Provider> ancestor. The HOC alone does not supply
// it in @aws-amplify/ui-react v3, so wrap the root render here.
// Mock mode renders App directly (no Amplify) and must NOT load the provider.
let Root = <App />;
if (!isMock) {
  const { Authenticator } = require('@aws-amplify/ui-react');
  Root = (
    <Authenticator.Provider>
      <App />
    </Authenticator.Provider>
  );
}

// --- 전역 axios 재시도 인터셉터 ---------------------------------------------
// stag 백엔드의 간헐적 503(낮은 Lambda 동시성)·네트워크 끊김을 멱등(GET) 요청에
// 한해 지수 백오프로 최대 2회 자동 재시도해 "데이터가 가끔 안 뜸"을 줄인다.
// POST/PUT 등 바디 있는 변경 요청은 중복 저장 방지를 위해 재시도하지 않는다.
const AXIOS_RETRY_MAX = 2;
const AXIOS_RETRY_STATUS = [408, 429, 502, 503, 504];
axios.interceptors.response.use(
	(response) => response,
	async (error) => {
		const config = error && error.config;
		if (!config || !config.method) return Promise.reject(error);
		const method = String(config.method).toLowerCase();
		const isReadOnly =
			(method === 'get' || method === 'head' || method === 'options') && !config.data;
		const status = error.response && error.response.status;
		const isTransient = !error.response || AXIOS_RETRY_STATUS.indexOf(status) !== -1;
		if (!isReadOnly || !isTransient) return Promise.reject(error);
		config.__retryCount = (config.__retryCount || 0) + 1;
		if (config.__retryCount > AXIOS_RETRY_MAX) return Promise.reject(error);
		const backoffMs = 600 * Math.pow(2, config.__retryCount - 1);
		await new Promise((resolve) => setTimeout(resolve, backoffMs));
		return axios(config);
	}
);

ReactDOM.render(Root, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
